// extracted by mini-css-extract-plugin
export var assigneeBadge = "_in-0";
export var assigneeDetails = "_in-1";
export var assigneeInfo = "_in-2";
export var dropdownContainer = "_in-4";
export var dropdownImage = "_in-5";
export var editAssigneeInfo = "_in-3";
export var editAssigneeModalContainer = "_in-6";
export var hidden = "_in-8";
export var input = "_in-7";